<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div v-if="data" class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 class="modal-title">Cambiar localización</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group" :class="{ 'has-error' : errors.has('place_id') }">
								<label class="control-label">Localización</label>
								<select
									@change="changePlace"
									name="place_id"
									v-validate="'required'"
									v-model="data.place_id"
									class="form-control">
									<template v-if="data.customer">
										<template v-if="data.customer.places">
											<template v-if="data.customer.places.length">
												<option v-for="place in data.customer.places" :value="place.id">{{ place.formatted_address }}</option>
											</template>
										</template>
									</template>
								</select>
								<small v-show="errors.has('place_id')" class="form-text text-danger">
									{{ errors.first('place_id') }}
								</small>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VueElementLoading from 'vue-element-loading'
	import swal from 'sweetalert2'
	
	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-budget-change-place'
				},
				loading: false,
			}
		},
		methods: {
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			changePlace() {
				this.loading = true
				var data = {
					place_id: this.data.place_id
				}
				this.$http.get('admin/management/budgets/' + this.data.id + '/change/place/' + this.data.place_id)
				.then(response => {
					this.loading = false
					this.$emit('reload')
					this.close()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					this.loading = false
					this.$emit('reload')
				})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/budgets/views/Places.vue